var map = {
	"./Fuss_Outline.svg": 552,
	"./Fuss_farbig.svg": 553,
	"./Haende_Outline.svg": 554,
	"./Haende_farbig.svg": 555,
	"./Hand_Outline.svg": 556,
	"./Hand_farbig.svg": 557,
	"./Nacken_Outline.svg": 558,
	"./Nacken_farbig.svg": 559,
	"./Ruecken_Outline.svg": 560,
	"./Ruecken_farbig.svg": 561,
	"./Schroepfen_Outline.svg": 562,
	"./Schroepfen_farbig.svg": 563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 551;